import { useState } from "react";
import { RecommenderModal } from "@features/recommender";
import { AiButton } from "@features/recommender/AIButton";
import { getModalHiddenState } from "@features/recommender/storage";
import { RecommendedItem } from "../hooks/useRecommededHistoricQuotes";
import { useInvestmentRecommendations } from "../hooks/useInvestmentRecommendations";
import { RecommendedItems } from "../types";

interface Props {
  investmentId: number;
  isin?: string;
  recommendedItems: RecommendedItems;
  onRecommendationSelect: (item: RecommendedItem, index: number) => void;
}

export const InvestmentRecommender = ({
  investmentId,
  isin,
  recommendedItems,
  onRecommendationSelect,
}: Props) => {
  const { recommendations, isRecommenderEnabled } =
    useInvestmentRecommendations(isin);
  const [isModalOpen, setIsModalOpen] = useState(
    isRecommenderEnabled && !getModalHiddenState(investmentId.toString())
  );

  return (
    <>
      <RecommenderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={onRecommendationSelect}
        recommendations={recommendations}
        isin={isin ?? ""}
        investmentId={investmentId}
        selectedTickers={Object.values(recommendedItems)
          .filter((item) => item)
          .map((item) => item.tickerSymbol)}
      />
      {recommendations.length > 0 && isRecommenderEnabled && (
        <AiButton onClick={() => setIsModalOpen(true)} />
      )}
    </>
  );
};
